import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    LeaseType, RegionFirstLevel,
    ProductType, TemperatureRange,
} from 'app/enums/label.enums'
import {
    ForecastFilterRequestResponse,
} from 'app/requests/Forecast/Forecast.types'

const config: SkyNetTableConfig<keyof ForecastFilterRequestResponse> = {
    name: 'ForecastOngoingOpportunities',
    tabs: [{
        name: 'Latest Submissions',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'validAsOf',
                labelKey: 'Forecasts.validFrom',
                filterField: 'validAsOf',
                filterType: FilterType.DateRange,
                reduced: true,
            },
            {
                name: 'accountName',
                labelKey: 'Forecasts.accountName',
                filterField: 'accountName',
                filterType: FilterType.Array,
                reduced: true,
            },
            {
                name: 'temperatureRange',
                labelKey: 'AccountQuotes.opportunityTempRange',
                componentName: 'EnumValue',
                allowedValuesEnum: TemperatureRange,
                reduced: true,
            },
            {
                name: 'productType',
                labelKey: 'Forecasts.productType',
                componentName: 'EnumValue',
                allowedValuesEnum: ProductType,
                filterField: 'productType',
                filterType: FilterType.Array,
            },
            {
                name: 'leaseType',
                labelKey: 'Forecasts.leaseType',
                componentName: 'EnumValue',
                allowedValuesEnum: LeaseType,
                filterField: 'leaseType',
                filterType: FilterType.Array,
            },
            {
                name: 'originAirportRegionFirstLevel',
                labelKey: 'RegionalGroups.originRegion',
                componentName: 'EnumValue',
                filterField: 'originAirportRegionFirstLevel',
                filterType: FilterType.Array,
                allowedValuesEnum: RegionFirstLevel,
            },
            {
                name: 'originAirportIataCode',
                labelKey: 'Forecasts.originAirport',
                filterField: 'originAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationAirportRegionFirstLevel',
                labelKey: 'RegionalGroups.destinationRegion',
                filterField: 'destinationAirportRegionFirstLevel',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: RegionFirstLevel,
            },
            {
                name: 'destinationAirportIataCode',
                labelKey: 'Forecasts.destinationAirport',
                filterField: 'destinationAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'changedOn',
                labelKey: 'Forecasts.changedOn',
                filterField: 'changedOn',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
            },
            {
                name: 'changedBy',
                labelKey: 'Forecasts.changedBy',
                filterField: 'changedBy',
                filterType: FilterType.Array,
            },
        ],
    }],
}

export default config
